module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-dialog', {
    staticClass: "middle-dialog",
    attrs: {
      "append-to-body": "",
      "show-footer": false,
      "title": _vm.$tx('审批进度', 'order.approvalPprogress'),
      "width": "640px",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [(_vm.dialogVisible) ? _c('rt-approval-progress', {
    attrs: {
      "entity-name": _vm.entityName,
      "entity-id": _vm.entityId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09974913"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/approval/src/progress-dialog.vue
// module id = 2071
// module chunks = 137